
        import { NgModule } from '@angular/core';
        import { DatosRoutingModule } from './datos-routing.module';
        import { DatosService } from './services/datos.service';
  
        @NgModule({
          declarations: [],
          imports: [
            DatosRoutingModule
          ],
          providers: [
            DatosService
          ]
        })
        export class DatosModule { }
    